const provinceMap = {
	type: 'FeatureCollection',
	features: [
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[30.193859794000048, -31.081260201999953],
						[30.142759983000076, -31.022820026999966],
						[30.146350037000047, -30.931069969999953],
						[30.092709971000033, -30.86222996799995],
						[29.974799962000077, -30.838079955999945],
						[29.94686997200006, -30.76994996999997],
						[29.852609983000036, -30.76160002699993],
						[29.70792995900007, -30.70478996099996],
						[29.675369982000063, -30.669939978999935],
						[29.59418997100005, -30.667439971999954],
						[29.51235997200007, -30.61821998299996],
						[29.372800038000037, -30.64896003499996],
						[29.26132997600007, -30.621159976999934],
						[29.16809998100007, -30.613079979999952],
						[29.15774997300008, -30.55382996999998],
						[29.196769982000035, -30.43439003499998],
						[29.305009976000065, -30.379859949999968],
						[29.301859965000062, -30.320119956999974],
						[29.13716997100005, -30.26233997199995],
						[29.10368997300003, -30.180540035999968],
						[29.117240037000045, -30.10018996799994],
						[29.044949978000034, -30.01296998199996],
						[29.01473997200003, -30.00179996999998],
						[28.985330004000048, -30.031369998999935],
						[28.858790001000045, -30.088229996999928],
						[28.68988999800007, -30.124289998999984],
						[28.667609997000056, -30.140710001999935],
						[28.568249999000045, -30.122860000999935],
						[28.451470002000065, -30.15783999799993],
						[28.365100003000066, -30.168620003999933],
						[28.340290003000064, -30.234610001999954],
						[28.23643000100003, -30.259939996999947],
						[28.215359997000064, -30.306809998999938],
						[28.27078000000006, -30.37082000299995],
						[28.22895999800005, -30.430079999999975],
						[28.15558999600006, -30.471829990999936],
						[28.17735000400006, -30.522410002999948],
						[28.114130001000035, -30.59903000199995],
						[28.12320000400007, -30.663389997999957],
						[27.94052000100004, -30.644109998999966],
						[27.918350003000057, -30.602589998999974],
						[27.78166999900003, -30.617299999999943],
						[27.623600001000057, -30.506200000999968],
						[27.604400003000023, -30.449459996999963],
						[27.534019998000076, -30.38435999799998],
						[27.474959996000052, -30.356479999999976],
						[27.46458999600003, -30.314029999999946],
						[27.37735000300006, -30.327119995999965],
						[27.403009994000058, -30.39297000399995],
						[27.34458999700007, -30.397330000999943],
						[27.29353999800003, -30.456750000999932],
						[27.284489999000073, -30.503400002999967],
						[27.188450002000025, -30.52379000199994],
						[27.00364999800007, -30.538309995999953],
						[27.042729999000073, -30.586360000999946],
						[26.94789999900007, -30.607639999999947],
						[26.94301000200005, -30.66214999799996],
						[26.847679997000057, -30.68386999699993],
						[26.814140004000024, -30.642670002999978],
						[26.70656000200006, -30.685679997999955],
						[26.629450004000034, -30.693879997999943],
						[26.481230003000064, -30.627629998999964],
						[26.425180002000047, -30.56523999799998],
						[26.34891000400006, -30.594969998999943],
						[26.294230004000042, -30.591000003999966],
						[26.259649999000032, -30.540720000999954],
						[26.193830002000027, -30.52797999699993],
						[26.162559999000052, -30.483489996999936],
						[26.097999999000024, -30.516500005999944],
						[25.973089990000062, -30.53938999299993],
						[25.778900001000068, -30.67587999999995],
						[25.700139996000075, -30.679509999999937],
						[25.63086000000004, -30.65934999999996],
						[25.60308999700004, -30.594389999999976],
						[25.467099997000048, -30.624210010999946],
						[25.48020000200006, -30.77890999999994],
						[25.521629998000037, -30.83318000099996],
						[25.471289999000078, -30.869840000999943],
						[25.51759000000004, -30.903389997999966],
						[25.47502000000003, -30.983879999999942],
						[25.486750001000075, -31.036910003999935],
						[25.446389999000075, -31.10020000199995],
						[25.384560001000068, -31.150970000999962],
						[25.38621000100005, -31.21784000399998],
						[25.354419997000036, -31.23599999399994],
						[25.22504000300006, -31.195199999999943],
						[25.170479998000076, -31.23917999899993],
						[25.05847000400007, -31.269379999999956],
						[25.00562000000008, -31.263099998999962],
						[24.94197000500003, -31.315069998999945],
						[24.852990005000038, -31.328209989999948],
						[24.788679998000077, -31.389460002999954],
						[24.704810003000034, -31.400590001999944],
						[24.664990001000035, -31.38366000999997],
						[24.56719000100003, -31.41864000099997],
						[24.558850001000053, -31.481839995999962],
						[24.503910002000055, -31.568419998999957],
						[24.522960003000037, -31.603689997999936],
						[24.514129996000065, -31.704970000999936],
						[24.345990001000075, -31.714480004999984],
						[24.26825000300005, -31.76666999699995],
						[24.161589996000032, -31.740149993999978],
						[24.152459995000072, -31.78860999799997],
						[24.105380000000025, -31.906850001999942],
						[24.164199997000026, -31.902410002999943],
						[24.222410000000025, -31.95564000099995],
						[24.140870001000053, -32.01170999799996],
						[24.10967499700007, -32.084289998999964],
						[24.13552999700005, -32.12314000099997],
						[24.100129996000078, -32.16399999999993],
						[23.961149999000042, -32.20652000399997],
						[23.892299997000066, -32.25494999599994],
						[23.79785000100003, -32.19407000299998],
						[23.670450002000052, -32.23767000399994],
						[23.648870002000024, -32.29801999599994],
						[23.66514999900005, -32.344229997999946],
						[23.448959998000078, -32.323269997999944],
						[23.40985000200004, -32.38919999899997],
						[23.33305000400003, -32.35113999799995],
						[23.307329999000046, -32.39592000199997],
						[23.221610003000023, -32.42503999999997],
						[23.24447000400005, -32.513229998999975],
						[23.288155001000064, -32.55120999799993],
						[23.30130999800008, -32.65178999899996],
						[23.37862000100006, -32.82501999599998],
						[23.149329996000063, -32.766739997999935],
						[23.08935000100007, -32.79917999699995],
						[23.098009998000066, -32.87369000899997],
						[23.007439997000063, -32.872819998999944],
						[22.948750001000064, -32.950040000999934],
						[22.935210005000044, -33.01304000299996],
						[22.955310001000043, -33.073140000999956],
						[22.892269998000074, -33.14163000399998],
						[22.735740001000067, -33.39476999799996],
						[22.784499998000058, -33.41553000199997],
						[22.93478000300007, -33.42914000099995],
						[23.134800004000056, -33.38762000099996],
						[23.297124998000072, -33.38864000099994],
						[23.354879999000048, -33.441169996999975],
						[23.495619998000052, -33.44344001099995],
						[23.603999999000052, -33.49640000199997],
						[23.596199999000078, -33.572520003999955],
						[23.674980000000062, -33.62587001199995],
						[23.670440004000056, -33.67255999799994],
						[23.555529998000054, -33.67295999799995],
						[23.54127000400007, -33.699539999999956],
						[23.43994000200007, -33.717390000999956],
						[23.430070000000057, -33.761759997999945],
						[23.468049999000073, -33.80747999999994],
						[23.517920004000075, -33.78562000299996],
						[23.65522999800004, -33.88738999699996],
						[23.647020000000055, -33.98055999999997],
						[23.846519999000066, -34.02708999999993],
						[24.193609999000046, -34.066030001999934],
						[24.323920001000033, -34.103380002999984],
						[24.38194999700005, -34.10308000099997],
						[24.475380009000048, -34.16192000199993],
						[24.599060000000065, -34.18793000199997],
						[24.65895000300003, -34.174910000999944],
						[24.827279997000062, -34.211150001999954],
						[24.842940002000034, -34.141580001999955],
						[24.921540004000065, -34.078840000999946],
						[24.93680000100005, -34.005540002999965],
						[25.07785000000007, -33.964749998999935],
						[25.153719998000042, -33.96279999899997],
						[25.30553999700004, -33.993019998999955],
						[25.394940001000066, -34.03137000299995],
						[25.58925000000005, -34.05061000199993],
						[25.65292000100004, -34.02803999699995],
						[25.671400001000052, -33.98313000099995],
						[25.61251999900003, -33.948269997999944],
						[25.641490001000022, -33.85165000199993],
						[25.70396000200003, -33.79046000099993],
						[25.847249997000063, -33.722470003999945],
						[26.015859996000074, -33.70530999799996],
						[26.18834000100003, -33.72618999599996],
						[26.321880004000036, -33.767770000999974],
						[26.468390001000046, -33.77337999699995],
						[26.625920001000054, -33.71907999999996],
						[26.751729999000077, -33.65000999799997],
						[26.866710001000058, -33.62633000099993],
						[26.93632000200006, -33.58199999599998],
						[27.110969999000076, -33.52534000099996],
						[27.353709999000046, -33.36493000199994],
						[27.608599997000056, -33.21818999799996],
						[27.72796999800005, -33.12144000099994],
						[27.919659999000032, -33.02961000399995],
						[27.969119997000064, -32.97365000299993],
						[28.03451000000007, -32.94277999999997],
						[28.10765000300006, -32.873539996999966],
						[28.117580002000068, -32.83005999799997],
						[28.178550003000055, -32.78628999699998],
						[28.268969999000035, -32.75891000399997],
						[28.374500002000048, -32.690429998999946],
						[28.431509998000024, -32.63318999699993],
						[28.511730003000025, -32.60318999699996],
						[28.615889998000057, -32.49260000299995],
						[28.656959999000037, -32.47177000399995],
						[28.778410001000054, -32.349399999999946],
						[28.882419999000035, -32.27984999699993],
						[29.067699997000034, -32.088960003999944],
						[29.184000000000026, -31.950569996999945],
						[29.320399999000074, -31.810479999999984],
						[29.42226000100004, -31.69168999799996],
						[29.50186999600004, -31.66470999699993],
						[29.62391000300005, -31.586009997999952],
						[29.759189996000032, -31.45239000099997],
						[29.834459999000046, -31.443250002999946],
						[30.068720002000077, -31.23765999999995],
						[30.193859794000048, -31.081260201999953]
					]
				]
			},
			properties: {
				Shape_Leng: 28.2273014967,
				Shape_Area: 16.1546677712,
				ADM1_EN: 'Eastern Cape',
				ADM1_PCODE: 'ZA2',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'EC'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[28.24428000000006, -26.88477999899993],
						[28.119130003000066, -26.889280011999972],
						[28.008180001000028, -26.770149998999955],
						[27.999559998000052, -26.69601999899993],
						[27.969109999000068, -26.66879000299997],
						[27.873640003000048, -26.747630000999948],
						[27.782800003000034, -26.75060999899995],
						[27.661369998000055, -26.773190002999968],
						[27.590429997000058, -26.73836000299997],
						[27.517359997000028, -26.781970000999934],
						[27.476040001000058, -26.883490000999927],
						[27.407530002000044, -26.925779989999967],
						[27.306050003000053, -26.85333999599993],
						[27.219160002000024, -26.944359995999946],
						[27.17366000100003, -26.96759000199995],
						[27.11343000200003, -26.926359996999963],
						[27.013929998000037, -26.932050001999983],
						[26.947220010000024, -26.89200999899998],
						[26.90868000000006, -26.945709999999963],
						[26.86858999800006, -26.919870000999936],
						[26.80502000200005, -26.931979998999964],
						[26.67182000200006, -26.99573000099997],
						[26.621069997000063, -27.00272000299998],
						[26.473629999000025, -27.15375999899993],
						[26.420610003000036, -27.17342999999994],
						[26.496769998000048, -27.26495999499997],
						[26.423090004000073, -27.40686999899998],
						[26.345160001000067, -27.38542999799995],
						[26.267750000000035, -27.416309997999974],
						[26.22041000300004, -27.47300000399997],
						[26.22724000200003, -27.51340999599995],
						[26.125510000000077, -27.564780009999936],
						[26.074959999000043, -27.621029998999973],
						[26.092639999000028, -27.696049998999968],
						[26.026190003000067, -27.73469999699995],
						[26.002289998000037, -27.648889992999955],
						[25.92687999700007, -27.60387000099996],
						[25.85260999700006, -27.620979999999975],
						[25.827370002000066, -27.56673000199993],
						[25.677420002000076, -27.630789996999965],
						[25.657800000000066, -27.69485999699998],
						[25.596609999000066, -27.65506999699994],
						[25.55583000200005, -27.686659997999982],
						[25.47943000300006, -27.69338000099998],
						[25.364029997000046, -27.750540000999933],
						[25.340420004000066, -27.792959998999947],
						[25.277410003000057, -27.795319995999932],
						[25.20094000100005, -27.886589998999966],
						[25.09060000200003, -27.984029998999972],
						[25.074650009000038, -28.064249995999944],
						[25.028080000000045, -28.07348000199994],
						[24.964569994000044, -28.25073999899996],
						[24.926679998000054, -28.24689999499998],
						[24.890329997000038, -28.31023000099998],
						[24.93761998900004, -28.324919989999955],
						[24.827729996000073, -28.62695999699997],
						[24.90184000000005, -28.64803000099994],
						[24.66192000500007, -29.079159998999955],
						[24.347519998000053, -29.65449999599997],
						[24.34866000100004, -29.70198999799993],
						[24.411580000000072, -29.79073999999997],
						[24.543859997000027, -29.843299999999942],
						[24.60792999800003, -29.91126000299994],
						[24.667799998000078, -29.906509994999965],
						[24.67129999900004, -29.971449999999948],
						[24.793970003000027, -29.99897999799998],
						[24.796240003000037, -30.04483999799993],
						[24.86768999700007, -30.130939997999974],
						[24.90156000500008, -30.208240003999947],
						[25.035619999000062, -30.34420999799994],
						[25.09371999700005, -30.37145999699993],
						[25.151909997000075, -30.45729999699995],
						[25.23710999900004, -30.50122999299998],
						[25.307119999000065, -30.57707999799993],
						[25.376580002000026, -30.55988999699997],
						[25.467099997000048, -30.624210010999946],
						[25.60308999700004, -30.594389999999976],
						[25.63086000000004, -30.65934999999996],
						[25.700139996000075, -30.679509999999937],
						[25.778900001000068, -30.67587999999995],
						[25.973089990000062, -30.53938999299993],
						[26.097999999000024, -30.516500005999944],
						[26.162559999000052, -30.483489996999936],
						[26.193830002000027, -30.52797999699993],
						[26.259649999000032, -30.540720000999954],
						[26.294230004000042, -30.591000003999966],
						[26.34891000400006, -30.594969998999943],
						[26.425180002000047, -30.56523999799998],
						[26.481230003000064, -30.627629998999964],
						[26.629450004000034, -30.693879997999943],
						[26.70656000200006, -30.685679997999955],
						[26.814140004000024, -30.642670002999978],
						[26.847679997000057, -30.68386999699993],
						[26.94301000200005, -30.66214999799996],
						[26.94789999900007, -30.607639999999947],
						[27.042729999000073, -30.586360000999946],
						[27.00364999800007, -30.538309995999953],
						[27.188450002000025, -30.52379000199994],
						[27.284489999000073, -30.503400002999967],
						[27.29353999800003, -30.456750000999932],
						[27.34458999700007, -30.397330000999943],
						[27.403009994000058, -30.39297000399995],
						[27.37735000300006, -30.327119995999965],
						[27.36585999700003, -30.257939997999983],
						[27.39414999400003, -30.142469996999978],
						[27.326890001000038, -30.14812000099994],
						[27.29654000000005, -30.056109995999975],
						[27.22294000000005, -29.996769996999944],
						[27.09657999700005, -29.729929995999953],
						[27.013910002000046, -29.661750000999973],
						[27.11970999700003, -29.57752999799993],
						[27.277870003000032, -29.526259998999933],
						[27.370469997000043, -29.44874999999996],
						[27.472289998000065, -29.318460002999984],
						[27.54762998900003, -29.24636000299995],
						[27.551400004000072, -29.196160001999942],
						[27.61416999900007, -29.16417999999993],
						[27.716229998000074, -29.004439998999942],
						[27.73076999700004, -28.94571000999997],
						[27.832939999000075, -28.90632999999997],
						[27.888919996000027, -28.91647999999998],
						[27.915960003000066, -28.865149994999967],
						[28.02843000100006, -28.873949997999944],
						[28.119080004000068, -28.741589997999938],
						[28.195410007000078, -28.710749997999983],
						[28.35281999600005, -28.700249996999958],
						[28.41324001600003, -28.62741998599995],
						[28.472089984000036, -28.605369982999946],
						[28.56841998400006, -28.608289983999953],
						[28.64814000000007, -28.571389997999972],
						[28.703099997000038, -28.619400001999963],
						[28.704609997000034, -28.67130999799997],
						[28.794959997000035, -28.699749999999938],
						[28.807780002000072, -28.770869999999945],
						[28.873626972000068, -28.77071189999998],
						[28.896229979000054, -28.69473998199993],
						[28.942769955000074, -28.650900028999956],
						[28.973990977000028, -28.574560038999948],
						[29.096319970000025, -28.54509003399994],
						[29.134999968000045, -28.566299966999964],
						[29.21624995700006, -28.519049953999968],
						[29.19149997900007, -28.493779977999964],
						[29.248749971000052, -28.42489996699993],
						[29.29009997000003, -28.437890033999963],
						[29.373410028000023, -28.37189997699994],
						[29.414309968000055, -28.375910015999978],
						[29.482929971000033, -28.27219996699995],
						[29.619765027000028, -28.241219959999967],
						[29.66284995700005, -28.177250025999967],
						[29.655479977000027, -28.090020025999934],
						[29.616861983000035, -28.04683801599998],
						[29.65764997800005, -27.937400023999942],
						[29.690349971000046, -27.895729966999966],
						[29.708990037000035, -27.69849996599993],
						[29.67011997900005, -27.67012997699993],
						[29.779559971000026, -27.587300031999973],
						[29.75835997200005, -27.52711003299993],
						[29.70316998100003, -27.471999970999946],
						[29.75867998600006, -27.442570014999944],
						[29.704269999000076, -27.489400001999968],
						[29.618910002000064, -27.506020001999957],
						[29.46898999600006, -27.32420000299993],
						[29.44343000300006, -27.266929997999966],
						[29.22980999400005, -27.16722999899997],
						[29.136369999000067, -27.154220002999978],
						[29.08601000300007, -27.115259997999942],
						[29.03884000000005, -27.022130001999983],
						[28.954770001000043, -27.01146000199998],
						[28.81085999800007, -27.038610003999963],
						[28.646920004000037, -26.953039996999962],
						[28.585470052000062, -27.035860016999948],
						[28.549689998000076, -27.04159999999996],
						[28.485850002000063, -26.971109997999974],
						[28.43456999700004, -27.00247000099995],
						[28.392150000000072, -26.93142000299997],
						[28.300429999000073, -26.94016000199997],
						[28.24428000000006, -26.88477999899993]
					]
				]
			},
			properties: {
				Shape_Leng: 24.2498565231,
				Shape_Area: 11.9794280159,
				ADM1_EN: 'Free State',
				ADM1_PCODE: 'ZA4',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'FS'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[28.24428000000006, -26.88477999899993],
						[28.325010001000066, -26.84107000299997],
						[28.319410004000076, -26.79266999699996],
						[28.406850002000056, -26.761710001999973],
						[28.40009999700004, -26.655044999999973],
						[28.483250001000044, -26.618379999999945],
						[28.641620001000035, -26.507569995999972],
						[28.763910003000035, -26.518009998999958],
						[28.789930001000073, -26.426450002999957],
						[28.861289998000075, -26.398569995999935],
						[28.805080002000068, -26.30659000199995],
						[28.710120010000026, -26.34124000099996],
						[28.62690000200007, -26.292439996999974],
						[28.622290003000046, -26.24837999799996],
						[28.53053999900004, -26.225309994999975],
						[28.534290002000034, -26.172240000999977],
						[28.49050000400007, -26.126392000999942],
						[28.538629996000054, -26.04781000199995],
						[28.632260004000045, -25.970779996999966],
						[28.793860004000067, -26.004569999999944],
						[28.885049996000077, -25.974399997999967],
						[28.888960002000033, -25.88032999799998],
						[28.93817999600003, -25.888640000999942],
						[28.938169999000024, -25.823284995999927],
						[28.981310002000043, -25.74254000199994],
						[28.968830000000025, -25.67330999799998],
						[29.064620001000037, -25.64241999899997],
						[29.007760003000044, -25.57416000099994],
						[28.946540000000027, -25.599799996999934],
						[28.851780003000044, -25.501809999999978],
						[28.846950004000064, -25.68242000099997],
						[28.792730001000052, -25.70242999499993],
						[28.76631000200007, -25.64697999899994],
						[28.723870000000034, -25.63177000099995],
						[28.683779997000045, -25.67537999999996],
						[28.625750002000075, -25.52304999599994],
						[28.62257999800005, -25.33364999899993],
						[28.732429999000033, -25.269169999999974],
						[28.77541000000008, -25.18377000299995],
						[28.74458899700005, -25.10961200099996],
						[28.651569996000035, -25.142899996999972],
						[28.615870002000065, -25.15162999699993],
						[28.659309999000072, -25.234780000999933],
						[28.513280004000023, -25.256149998999945],
						[28.503590001000077, -25.30883999899993],
						[28.38260000500003, -25.321149999999932],
						[28.298160001000042, -25.310370001999956],
						[28.298060004000035, -25.33933999599998],
						[28.04473000400003, -25.401739994999957],
						[28.00040999600003, -25.35942000299997],
						[27.945639996000068, -25.40670000299997],
						[28.03595000400003, -25.470589996999934],
						[27.95763000100004, -25.59261999699993],
						[27.98056001200007, -25.632800006999958],
						[27.948190000000068, -25.695210003999932],
						[27.960169997000037, -25.815989996999974],
						[27.858739997000043, -25.81881999899997],
						[27.831470000000024, -25.86017299799994],
						[27.744549997000036, -25.894620002999943],
						[27.684930000000065, -25.875400000999946],
						[27.643549999000072, -25.79591999799993],
						[27.55984999800006, -25.842839998999978],
						[27.461947001000055, -25.867606000999956],
						[27.457009997000057, -25.981849997999973],
						[27.419440004000023, -26.117499995999935],
						[27.358259993000047, -26.154609999999934],
						[27.291409998000063, -26.144620003999933],
						[27.330071000000032, -26.28181499899995],
						[27.187952000000053, -26.377862998999944],
						[27.22484999900007, -26.44396999999998],
						[27.231421002000047, -26.50548099599996],
						[27.158760003000054, -26.52541999899995],
						[27.182637003000025, -26.574619995999967],
						[27.22835999700004, -26.571050000999946],
						[27.241869998000027, -26.636459999999943],
						[27.378349998000033, -26.610679997999966],
						[27.569090002000053, -26.647160003999943],
						[27.590429997000058, -26.73836000299997],
						[27.661369998000055, -26.773190002999968],
						[27.782800003000034, -26.75060999899995],
						[27.873640003000048, -26.747630000999948],
						[27.969109999000068, -26.66879000299997],
						[27.999559998000052, -26.69601999899993],
						[28.008180001000028, -26.770149998999955],
						[28.119130003000066, -26.889280011999972],
						[28.24428000000006, -26.88477999899993]
					]
				]
			},
			properties: {
				Shape_Leng: 10.967458387,
				Shape_Area: 1.64038198144,
				ADM1_EN: 'Gauteng',
				ADM1_PCODE: 'ZA7',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'GT'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[30.193859794000048, -31.081260201999953],
						[30.22747994300005, -31.05828994099994],
						[30.304470068000057, -30.941329940999935],
						[30.40450994300005, -30.82830006599994],
						[30.673689943000056, -30.420270065999944],
						[30.735679943000036, -30.338809940999965],
						[30.759619943000075, -30.27754994099996],
						[30.898679943000047, -30.041720064999936],
						[30.968519943000047, -29.982329939999943],
						[31.061419943000033, -29.87597993999998],
						[31.038409943000033, -29.823229939999976],
						[31.128019943000027, -29.65357993999993],
						[31.34081994400003, -29.382049939999945],
						[31.453509944000075, -29.267600064999954],
						[31.57352994400003, -29.165789939999968],
						[31.765349944000036, -28.965429938999932],
						[31.91853994400003, -28.917469938999943],
						[32.02933994400007, -28.86539993899993],
						[32.368949945000054, -28.568400063999945],
						[32.41476794500005, -28.476392938999936],
						[32.47060794500004, -28.48533593899998],
						[32.48299794500008, -28.388292063999984],
						[32.56621894500006, -28.24935006399994],
						[32.61464694500006, -28.141686938999953],
						[32.64947194500007, -27.942397937999942],
						[32.66396294500004, -27.790048937999984],
						[32.73619494500008, -27.541613062999943],
						[32.73423394500003, -27.506462062999958],
						[32.896498945000076, -27.12041506299994],
						[32.944984945000044, -26.871974937999937],
						[32.89133394500004, -26.857862936999936],
						[32.682949945000075, -26.868139936999967],
						[32.33242994500006, -26.863820061999945],
						[32.22029994500008, -26.832849936999935],
						[32.186330069000064, -26.862990061999938],
						[32.09255994400007, -26.804870061999964],
						[32.015859944000056, -26.81988006199998],
						[31.974549944000046, -27.116409937999947],
						[31.97775994400007, -27.31752006299996],
						[31.49368994400004, -27.31516006299995],
						[31.27432998000006, -27.24317002099997],
						[31.16586999200007, -27.368520012999966],
						[31.100959988000056, -27.335760020999942],
						[30.95578998900004, -27.35970998299996],
						[30.922159988000033, -27.305049981999957],
						[30.829679989000056, -27.350149981999948],
						[30.706799990000036, -27.283289986999932],
						[30.587739989000056, -27.322949980999965],
						[30.425979979000033, -27.31496001499994],
						[30.367609988000027, -27.267429979999974],
						[30.28248998600003, -27.314439981999953],
						[30.279930016000037, -27.368589975999953],
						[30.19807998400006, -27.355180022999946],
						[30.15023998600003, -27.392249985999968],
						[30.068289979000042, -27.36587001999993],
						[30.016241986000068, -27.39758901999994],
						[29.917219986000077, -27.354409982999982],
						[29.840189999000074, -27.37898998099996],
						[29.810689987000046, -27.444769979999933],
						[29.75867998600006, -27.442570014999944],
						[29.70316998100003, -27.471999970999946],
						[29.75835997200005, -27.52711003299993],
						[29.779559971000026, -27.587300031999973],
						[29.67011997900005, -27.67012997699993],
						[29.708990037000035, -27.69849996599993],
						[29.690349971000046, -27.895729966999966],
						[29.65764997800005, -27.937400023999942],
						[29.616861983000035, -28.04683801599998],
						[29.655479977000027, -28.090020025999934],
						[29.66284995700005, -28.177250025999967],
						[29.619765027000028, -28.241219959999967],
						[29.482929971000033, -28.27219996699995],
						[29.414309968000055, -28.375910015999978],
						[29.373410028000023, -28.37189997699994],
						[29.29009997000003, -28.437890033999963],
						[29.248749971000052, -28.42489996699993],
						[29.19149997900007, -28.493779977999964],
						[29.21624995700006, -28.519049953999968],
						[29.134999968000045, -28.566299966999964],
						[29.096319970000025, -28.54509003399994],
						[28.973990977000028, -28.574560038999948],
						[28.942769955000074, -28.650900028999956],
						[28.896229979000054, -28.69473998199993],
						[28.873626972000068, -28.77071189999998],
						[28.943810066000026, -28.782659938999927],
						[28.939220066000075, -28.859999938999977],
						[28.974890066000057, -28.892939938999973],
						[29.074789942000052, -28.918779938999933],
						[29.215490067000076, -29.02628993999997],
						[29.259249942000054, -29.09045993999996],
						[29.307819942000037, -29.076629939999975],
						[29.355509942000026, -29.12677993999995],
						[29.35662994200004, -29.201319939999962],
						[29.40742994200008, -29.211559939999972],
						[29.455609942000024, -29.341199939999967],
						[29.403389942000047, -29.444019939999976],
						[29.32934994200008, -29.47016006499996],
						[29.297219942000027, -29.522339939999938],
						[29.279189942000073, -29.644739939999965],
						[29.183429942000032, -29.66821993999997],
						[29.145239942000046, -29.71640993999995],
						[29.131659942000056, -29.825630064999928],
						[29.169419942000047, -29.91632006499998],
						[29.10898994200005, -29.936969939999983],
						[29.01473997200003, -30.00179996999998],
						[29.044949978000034, -30.01296998199996],
						[29.117240037000045, -30.10018996799994],
						[29.10368997300003, -30.180540035999968],
						[29.13716997100005, -30.26233997199995],
						[29.301859965000062, -30.320119956999974],
						[29.305009976000065, -30.379859949999968],
						[29.196769982000035, -30.43439003499998],
						[29.15774997300008, -30.55382996999998],
						[29.16809998100007, -30.613079979999952],
						[29.26132997600007, -30.621159976999934],
						[29.372800038000037, -30.64896003499996],
						[29.51235997200007, -30.61821998299996],
						[29.59418997100005, -30.667439971999954],
						[29.675369982000063, -30.669939978999935],
						[29.70792995900007, -30.70478996099996],
						[29.852609983000036, -30.76160002699993],
						[29.94686997200006, -30.76994996999997],
						[29.974799962000077, -30.838079955999945],
						[30.092709971000033, -30.86222996799995],
						[30.146350037000047, -30.931069969999953],
						[30.142759983000076, -31.022820026999966],
						[30.193859794000048, -31.081260201999953]
					]
				]
			},
			properties: {
				Shape_Leng: 19.0591857159,
				Shape_Area: 8.71537946494,
				ADM1_EN: 'KwaZulu-Natal',
				ADM1_PCODE: 'ZA5',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'KZN'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[31.883834663000073, -23.984594453999932],
						[31.880720001000043, -23.95505000199995],
						[31.76918000300003, -23.88779999999997],
						[31.697390004000056, -23.721889992999934],
						[31.69054999900004, -23.629440002999957],
						[31.561020000000042, -23.481959996999933],
						[31.550730001000034, -23.41028000199998],
						[31.563599990000057, -23.19822999799993],
						[31.475255564000065, -22.92559381199993],
						[31.30923000300004, -22.427559989999963],
						[31.273680004000028, -22.37476000199996],
						[31.220869995000044, -22.369809999999973],
						[31.161999998000056, -22.328419999999937],
						[31.094109999000068, -22.348689995999962],
						[30.99967999900008, -22.31641998999993],
						[30.83917000200006, -22.29208000099993],
						[30.626089943000068, -22.336340056999973],
						[30.491889943000047, -22.316590057999974],
						[30.379009944000074, -22.351300056999946],
						[30.28287994300007, -22.354010056999982],
						[30.227539944000057, -22.294980056999975],
						[30.121569944000044, -22.308670056999972],
						[30.019849942000064, -22.23344005799993],
						[29.923119943000074, -22.189180057999977],
						[29.80522994300003, -22.165500057999964],
						[29.773589942000058, -22.141420057999937],
						[29.67703994200008, -22.138970057999927],
						[29.541009942000073, -22.152270057999942],
						[29.331989942000064, -22.20417005799993],
						[29.217199943000026, -22.178310057999965],
						[29.154999942000074, -22.214520057999948],
						[29.03693994200006, -22.21631005699993],
						[28.966579942000067, -22.307540057999972],
						[28.97144994100006, -22.37698005799996],
						[28.943119942000067, -22.433889931999943],
						[28.88087999700008, -22.44783999999993],
						[28.83105000100005, -22.488250000999983],
						[28.710359999000048, -22.514749999999935],
						[28.639279999000053, -22.558710007999935],
						[28.342640001000063, -22.57372000099997],
						[28.209670001000063, -22.66446000199994],
						[28.15972000100004, -22.718329998999934],
						[28.16236999800003, -22.755859998999938],
						[28.039140004000046, -22.841910006999967],
						[28.036819999000045, -22.913029998999946],
						[27.935290001000055, -22.965570001999936],
						[27.943490000000054, -23.036219998999968],
						[27.92054999800007, -23.067779996999946],
						[27.765299995000078, -23.142420001999938],
						[27.78458000200004, -23.17247999899996],
						[27.741619998000033, -23.230410003999964],
						[27.672009997000032, -23.20047999899998],
						[27.575579998000023, -23.261340003999976],
						[27.563889997000047, -23.34816000099994],
						[27.528649999000038, -23.385269997999956],
						[27.46120999900006, -23.384000002999983],
						[27.427040000000034, -23.42577999599996],
						[27.34881000300004, -23.397520001999965],
						[27.30296000100003, -23.46266000199995],
						[27.19207999500003, -23.49847000099993],
						[27.13405000000006, -23.53663998999997],
						[27.081149998000058, -23.643310002999954],
						[26.999659998000027, -23.65244000299998],
						[26.971070000000054, -23.702759998999966],
						[26.908940001000076, -24.029180002999965],
						[26.86320000300003, -24.09972000399995],
						[26.880610003000072, -24.196579996999958],
						[26.868809998000074, -24.243819995999957],
						[26.799930001000064, -24.299959996999974],
						[26.70399000200007, -24.32182000199998],
						[26.64705000200007, -24.38182999999998],
						[26.510520003000067, -24.487909999999943],
						[26.469550000000027, -24.590859997999928],
						[26.40878000300006, -24.646129995999956],
						[26.42731000200007, -24.657520002999945],
						[26.426319996000075, -24.771970003999968],
						[26.458340000000078, -24.809470001999955],
						[26.566450002000067, -24.819899998999972],
						[26.62201000300007, -24.809860003999972],
						[26.69930000100004, -24.867290003999983],
						[26.751259996000044, -24.88295999899998],
						[26.77954000300008, -24.837690002999977],
						[26.980720002000055, -24.77576999799993],
						[26.975909998000077, -24.720670001999963],
						[27.02632999900004, -24.71863000199994],
						[27.041219999000077, -24.88697000299993],
						[27.101150003000043, -24.90004000299996],
						[27.143852999000046, -24.946151003999944],
						[27.22609200200003, -24.963937001999966],
						[27.203468000000044, -25.033182997999972],
						[27.313600000000065, -25.042089996999948],
						[27.33695000000006, -25.08781999699994],
						[27.48175000200007, -25.067069999999944],
						[27.54359999600007, -25.09587999799993],
						[27.594040002000042, -25.029440000999955],
						[27.597490003000075, -24.984869999999944],
						[27.759140003000027, -24.968910000999983],
						[27.946469998000055, -25.001219999999932],
						[27.95495000300008, -24.97016999799996],
						[28.12521999100005, -25.004800001999968],
						[28.25975999700006, -25.050449999999955],
						[28.19827000300006, -25.12759000099993],
						[28.128970002000074, -25.145689989999937],
						[28.13571999900006, -25.20563999799998],
						[28.246270001000028, -25.212855003999948],
						[28.298160001000042, -25.310370001999956],
						[28.38260000500003, -25.321149999999932],
						[28.503590001000077, -25.30883999899993],
						[28.513280004000023, -25.256149998999945],
						[28.659309999000072, -25.234780000999933],
						[28.615870002000065, -25.15162999699993],
						[28.651569996000035, -25.142899996999972],
						[28.536829999000076, -25.152549990999944],
						[28.461599997000064, -25.20147999699998],
						[28.411020001000054, -25.20482999999996],
						[28.379259999000055, -25.155299998999965],
						[28.44297000100005, -25.128989988999933],
						[28.473739998000042, -25.08931999899994],
						[28.634289996000064, -25.058240001999934],
						[28.605540003000044, -25.003799997999977],
						[28.713779997000074, -24.95362000199998],
						[28.759379997000053, -24.91135000099996],
						[28.837390001000074, -24.91600999999997],
						[28.89165997200007, -24.955459962999953],
						[28.971709970000063, -25.070179966999945],
						[29.070663960000047, -25.06546604199997],
						[29.12842997200005, -25.113039965999974],
						[29.042509981000023, -25.140500019999934],
						[29.038444972000036, -25.276459965999948],
						[29.095889973000055, -25.321180031999972],
						[29.166959960000042, -25.30336004199995],
						[29.16411997000006, -25.354480029999934],
						[29.207338979000042, -25.41457202099997],
						[29.264433960000076, -25.37546304199998],
						[29.398949972000025, -25.414830028999972],
						[29.612789973000076, -25.40061002999994],
						[29.67385997200006, -25.37216002899993],
						[29.77023997200007, -25.401530028999957],
						[29.840299972000025, -25.38632003099997],
						[29.937569971000073, -25.331020029999934],
						[30.006234971000026, -25.34033003099995],
						[30.005409971000063, -25.14438003099997],
						[30.029839997000067, -25.08456999999993],
						[30.144389997000076, -25.12378999899994],
						[30.148509997000076, -25.032350003999966],
						[30.17206999900003, -24.989169998999955],
						[30.19197998900006, -24.85547000899993],
						[30.297290000000032, -24.867740001999948],
						[30.42507000300003, -24.854859999999974],
						[30.45153999200005, -24.912000003999935],
						[30.562880003000032, -24.89646000099998],
						[30.634880004000024, -24.852770000999953],
						[30.67856999600008, -24.735809996999933],
						[30.720100002000038, -24.70523800899997],
						[30.679240003000075, -24.623670001999983],
						[30.730319997000038, -24.608729995999965],
						[30.73017999900003, -24.49849999999998],
						[30.758979999000076, -24.460219998999946],
						[30.871709999000075, -24.538500002999967],
						[30.954330011000025, -24.521279999999933],
						[30.95931999900006, -24.582070000999977],
						[31.226180011000054, -24.556010001999937],
						[31.25366000200006, -24.499120000999937],
						[31.159969998000065, -24.37557000199996],
						[31.242029998000078, -24.365430000999936],
						[31.200059999000075, -24.304949991999933],
						[31.05602000500005, -24.32188999699997],
						[31.04993999800007, -24.187319996999975],
						[31.10726999900004, -24.145730000999947],
						[31.120569998000065, -24.090259999999944],
						[31.19425000800004, -24.03114999899998],
						[31.252280003000067, -24.09773000299998],
						[31.428049998000063, -24.054499999999962],
						[31.44093999900008, -24.020980002999977],
						[31.594699999000056, -24.05636999799998],
						[31.665980002000026, -24.016699999999958],
						[31.73581000300004, -24.04607999999996],
						[31.767479998000056, -23.98461999999995],
						[31.883834663000073, -23.984594453999932]
					]
				]
			},
			properties: {
				Shape_Leng: 21.8600912349,
				Shape_Area: 11.1414116888,
				ADM1_EN: 'Limpopo',
				ADM1_PCODE: 'ZA9',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'LIM'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[31.883834663000073, -23.984594453999932],
						[31.767479998000056, -23.98461999999995],
						[31.73581000300004, -24.04607999999996],
						[31.665980002000026, -24.016699999999958],
						[31.594699999000056, -24.05636999799998],
						[31.44093999900008, -24.020980002999977],
						[31.428049998000063, -24.054499999999962],
						[31.252280003000067, -24.09773000299998],
						[31.19425000800004, -24.03114999899998],
						[31.120569998000065, -24.090259999999944],
						[31.10726999900004, -24.145730000999947],
						[31.04993999800007, -24.187319996999975],
						[31.05602000500005, -24.32188999699997],
						[31.200059999000075, -24.304949991999933],
						[31.242029998000078, -24.365430000999936],
						[31.159969998000065, -24.37557000199996],
						[31.25366000200006, -24.499120000999937],
						[31.226180011000054, -24.556010001999937],
						[30.95931999900006, -24.582070000999977],
						[30.954330011000025, -24.521279999999933],
						[30.871709999000075, -24.538500002999967],
						[30.758979999000076, -24.460219998999946],
						[30.73017999900003, -24.49849999999998],
						[30.730319997000038, -24.608729995999965],
						[30.679240003000075, -24.623670001999983],
						[30.720100002000038, -24.70523800899997],
						[30.67856999600008, -24.735809996999933],
						[30.634880004000024, -24.852770000999953],
						[30.562880003000032, -24.89646000099998],
						[30.45153999200005, -24.912000003999935],
						[30.42507000300003, -24.854859999999974],
						[30.297290000000032, -24.867740001999948],
						[30.19197998900006, -24.85547000899993],
						[30.17206999900003, -24.989169998999955],
						[30.148509997000076, -25.032350003999966],
						[30.144389997000076, -25.12378999899994],
						[30.029839997000067, -25.08456999999993],
						[30.005409971000063, -25.14438003099997],
						[30.006234971000026, -25.34033003099995],
						[29.937569971000073, -25.331020029999934],
						[29.840299972000025, -25.38632003099997],
						[29.77023997200007, -25.401530028999957],
						[29.67385997200006, -25.37216002899993],
						[29.612789973000076, -25.40061002999994],
						[29.398949972000025, -25.414830028999972],
						[29.264433960000076, -25.37546304199998],
						[29.207338979000042, -25.41457202099997],
						[29.16411997000006, -25.354480029999934],
						[29.166959960000042, -25.30336004199995],
						[29.095889973000055, -25.321180031999972],
						[29.038444972000036, -25.276459965999948],
						[29.042509981000023, -25.140500019999934],
						[29.12842997200005, -25.113039965999974],
						[29.070663960000047, -25.06546604199997],
						[28.971709970000063, -25.070179966999945],
						[28.89165997200007, -24.955459962999953],
						[28.837390001000074, -24.91600999999997],
						[28.759379997000053, -24.91135000099996],
						[28.713779997000074, -24.95362000199998],
						[28.605540003000044, -25.003799997999977],
						[28.634289996000064, -25.058240001999934],
						[28.473739998000042, -25.08931999899994],
						[28.44297000100005, -25.128989988999933],
						[28.379259999000055, -25.155299998999965],
						[28.411020001000054, -25.20482999999996],
						[28.461599997000064, -25.20147999699998],
						[28.536829999000076, -25.152549990999944],
						[28.651569996000035, -25.142899996999972],
						[28.74458899700005, -25.10961200099996],
						[28.77541000000008, -25.18377000299995],
						[28.732429999000033, -25.269169999999974],
						[28.62257999800005, -25.33364999899993],
						[28.625750002000075, -25.52304999599994],
						[28.683779997000045, -25.67537999999996],
						[28.723870000000034, -25.63177000099995],
						[28.76631000200007, -25.64697999899994],
						[28.792730001000052, -25.70242999499993],
						[28.846950004000064, -25.68242000099997],
						[28.851780003000044, -25.501809999999978],
						[28.946540000000027, -25.599799996999934],
						[29.007760003000044, -25.57416000099994],
						[29.064620001000037, -25.64241999899997],
						[28.968830000000025, -25.67330999799998],
						[28.981310002000043, -25.74254000199994],
						[28.938169999000024, -25.823284995999927],
						[28.93817999600003, -25.888640000999942],
						[28.888960002000033, -25.88032999799998],
						[28.885049996000077, -25.974399997999967],
						[28.793860004000067, -26.004569999999944],
						[28.632260004000045, -25.970779996999966],
						[28.538629996000054, -26.04781000199995],
						[28.49050000400007, -26.126392000999942],
						[28.534290002000034, -26.172240000999977],
						[28.53053999900004, -26.225309994999975],
						[28.622290003000046, -26.24837999799996],
						[28.62690000200007, -26.292439996999974],
						[28.710120010000026, -26.34124000099996],
						[28.805080002000068, -26.30659000199995],
						[28.861289998000075, -26.398569995999935],
						[28.789930001000073, -26.426450002999957],
						[28.763910003000035, -26.518009998999958],
						[28.641620001000035, -26.507569995999972],
						[28.483250001000044, -26.618379999999945],
						[28.40009999700004, -26.655044999999973],
						[28.406850002000056, -26.761710001999973],
						[28.319410004000076, -26.79266999699996],
						[28.325010001000066, -26.84107000299997],
						[28.24428000000006, -26.88477999899993],
						[28.300429999000073, -26.94016000199997],
						[28.392150000000072, -26.93142000299997],
						[28.43456999700004, -27.00247000099995],
						[28.485850002000063, -26.971109997999974],
						[28.549689998000076, -27.04159999999996],
						[28.585470052000062, -27.035860016999948],
						[28.646920004000037, -26.953039996999962],
						[28.81085999800007, -27.038610003999963],
						[28.954770001000043, -27.01146000199998],
						[29.03884000000005, -27.022130001999983],
						[29.08601000300007, -27.115259997999942],
						[29.136369999000067, -27.154220002999978],
						[29.22980999400005, -27.16722999899997],
						[29.44343000300006, -27.266929997999966],
						[29.46898999600006, -27.32420000299993],
						[29.618910002000064, -27.506020001999957],
						[29.704269999000076, -27.489400001999968],
						[29.75867998600006, -27.442570014999944],
						[29.810689987000046, -27.444769979999933],
						[29.840189999000074, -27.37898998099996],
						[29.917219986000077, -27.354409982999982],
						[30.016241986000068, -27.39758901999994],
						[30.068289979000042, -27.36587001999993],
						[30.15023998600003, -27.392249985999968],
						[30.19807998400006, -27.355180022999946],
						[30.279930016000037, -27.368589975999953],
						[30.28248998600003, -27.314439981999953],
						[30.367609988000027, -27.267429979999974],
						[30.425979979000033, -27.31496001499994],
						[30.587739989000056, -27.322949980999965],
						[30.706799990000036, -27.283289986999932],
						[30.829679989000056, -27.350149981999948],
						[30.922159988000033, -27.305049981999957],
						[30.95578998900004, -27.35970998299996],
						[31.100959988000056, -27.335760020999942],
						[31.16586999200007, -27.368520012999966],
						[31.27432998000006, -27.24317002099997],
						[31.150550002000045, -27.202080002999935],
						[31.06132999700003, -27.096290005999947],
						[30.984759997000026, -27.03698000199995],
						[30.958326003000025, -26.99212899799994],
						[30.973559995000073, -26.908210001999976],
						[30.90742000000006, -26.859929998999974],
						[30.88728499900003, -26.803584998999952],
						[30.81321999900007, -26.844480003999934],
						[30.790799998000068, -26.71228999699997],
						[30.791810000000055, -26.569109998999977],
						[30.805060000000026, -26.46667099499996],
						[30.891860001000055, -26.32082000099996],
						[30.96143799600003, -26.261731999999938],
						[31.11275000200004, -25.98256999599994],
						[31.126599997000028, -25.92114999699993],
						[31.263569997000047, -25.80963000299994],
						[31.315939998000033, -25.74304000099994],
						[31.416299999000046, -25.718759999999975],
						[31.867860003000033, -25.999600001999966],
						[31.97369000100008, -25.95320000299995],
						[31.93054999700007, -25.84076999699994],
						[31.97856000200005, -25.693670001999976],
						[32.00609900000006, -25.645193999999947],
						[31.979620002000047, -25.457059998999966],
						[32.01464999800004, -25.385560003999956],
						[32.03359000200004, -25.132519998999953],
						[31.998270003000073, -24.68974000199995],
						[32.01309999800003, -24.45458999999994],
						[31.987129998000057, -24.30219999999997],
						[31.908010003000072, -24.182429998999964],
						[31.883834663000073, -23.984594453999932]
					]
				]
			},
			properties: {
				Shape_Leng: 23.6512123095,
				Shape_Area: 6.88997253096,
				ADM1_EN: 'Mpumalanga',
				ADM1_PCODE: 'ZA8',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'MP'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[28.298160001000042, -25.310370001999956],
						[28.246270001000028, -25.212855003999948],
						[28.13571999900006, -25.20563999799998],
						[28.128970002000074, -25.145689989999937],
						[28.19827000300006, -25.12759000099993],
						[28.25975999700006, -25.050449999999955],
						[28.12521999100005, -25.004800001999968],
						[27.95495000300008, -24.97016999799996],
						[27.946469998000055, -25.001219999999932],
						[27.759140003000027, -24.968910000999983],
						[27.597490003000075, -24.984869999999944],
						[27.594040002000042, -25.029440000999955],
						[27.54359999600007, -25.09587999799993],
						[27.48175000200007, -25.067069999999944],
						[27.33695000000006, -25.08781999699994],
						[27.313600000000065, -25.042089996999948],
						[27.203468000000044, -25.033182997999972],
						[27.22609200200003, -24.963937001999966],
						[27.143852999000046, -24.946151003999944],
						[27.101150003000043, -24.90004000299996],
						[27.041219999000077, -24.88697000299993],
						[27.02632999900004, -24.71863000199994],
						[26.975909998000077, -24.720670001999963],
						[26.980720002000055, -24.77576999799993],
						[26.77954000300008, -24.837690002999977],
						[26.751259996000044, -24.88295999899998],
						[26.69930000100004, -24.867290003999983],
						[26.62201000300007, -24.809860003999972],
						[26.566450002000067, -24.819899998999972],
						[26.458340000000078, -24.809470001999955],
						[26.426319996000075, -24.771970003999968],
						[26.42731000200007, -24.657520002999945],
						[26.40878000300006, -24.646129995999956],
						[26.39328000100005, -24.63662999899998],
						[26.00741000200003, -24.724280005999958],
						[25.964409997000075, -24.749439999999936],
						[25.858310008000046, -24.757180002999974],
						[25.876570000000072, -24.888300001999937],
						[25.729100000000074, -25.256880002999935],
						[25.699819998000066, -25.291000002999965],
						[25.662369999000077, -25.466549997999948],
						[25.580879999000047, -25.63879998799996],
						[25.513660007000055, -25.684339997999928],
						[25.33413000300004, -25.77101999699994],
						[25.17011999700003, -25.765909999999963],
						[25.035730004000072, -25.722750007999934],
						[24.887260001000072, -25.807420001999958],
						[24.796320003000062, -25.824629998999967],
						[24.72967000400007, -25.804090002999942],
						[24.685869999000033, -25.82333000099993],
						[24.448470003000068, -25.73412000299993],
						[24.380810002000032, -25.764859996999974],
						[24.278469999000038, -25.713250002999928],
						[24.194069996000053, -25.62106999699995],
						[24.003529996000054, -25.650190003999967],
						[23.90337999700006, -25.626810000999967],
						[23.880239999000025, -25.577449999999942],
						[23.816089996000073, -25.55018000299998],
						[23.75825999700004, -25.469259996999938],
						[23.594380000000058, -25.397010000999956],
						[23.500439999000037, -25.33184999599996],
						[23.46826999900003, -25.27946999699998],
						[23.419860003000053, -25.313740001999975],
						[23.36049999200003, -25.28622999299995],
						[23.192250000000058, -25.277310002999968],
						[22.97794000300007, -25.33985999799995],
						[22.96761000400005, -25.38342999599996],
						[22.863750003000064, -25.479619997999976],
						[22.81481999600004, -25.57882000099994],
						[22.853459996000026, -25.611629996999966],
						[22.763719990000027, -25.77872999699997],
						[22.781409996000036, -25.828799997999965],
						[22.738069997000025, -25.85504000399993],
						[22.72104999800007, -26.018560002999948],
						[22.632170006000024, -26.121280000999946],
						[22.702940002000048, -26.11985000599998],
						[22.708800001000043, -26.410789998999974],
						[22.803159997000023, -26.453680000999952],
						[22.84187000000003, -26.39330000299998],
						[22.899290004000022, -26.213630000999956],
						[22.90705999900007, -26.14592000199997],
						[22.981149999000024, -26.152559999999937],
						[22.987040000000036, -26.089979995999954],
						[23.064800003000073, -26.099059994999948],
						[23.086910001000035, -25.982559995999964],
						[23.320549997000057, -25.99283999599993],
						[23.387359998000022, -26.006159999999966],
						[23.35388199700003, -26.08947800599998],
						[23.23214999700008, -26.052690002999952],
						[23.215819999000075, -26.115730003999943],
						[23.310979995000025, -26.141849999999977],
						[23.221740004000026, -26.271270000999948],
						[23.28205000300005, -26.339470002999974],
						[23.266410002000043, -26.48539999899998],
						[23.46295999800003, -26.53108999799997],
						[23.583750000000066, -26.617149997999945],
						[23.48713000300006, -26.739709004999952],
						[23.646530002000077, -26.807480001999977],
						[23.760750002000066, -26.840960000999928],
						[23.853230004000068, -26.890140002999942],
						[23.916070004000062, -26.858289997999975],
						[23.97037000100005, -26.894200001999934],
						[24.026019999000027, -26.99928999699995],
						[24.037450000000035, -27.053699998999946],
						[23.973560000000077, -27.096379997999975],
						[23.89646999400003, -27.252659998999945],
						[24.063919998000074, -27.35316999899993],
						[24.050610001000052, -27.602729996999983],
						[24.118620004000036, -27.621739997999953],
						[24.093339996000054, -27.704910005999977],
						[24.111000001000036, -27.73898000099996],
						[24.40528000100005, -27.681180001999962],
						[24.44676000000004, -27.70285000399997],
						[24.408839999000065, -27.761099996999974],
						[24.452310005000072, -27.782880002999946],
						[24.360459994000053, -27.91067000299995],
						[24.40994999800006, -27.923300001999962],
						[24.46728999900006, -27.980569998999954],
						[24.465479997000045, -28.035840005999944],
						[24.534620004000033, -28.092109999999934],
						[24.56281000000007, -28.036220000999947],
						[24.62935000300007, -27.994309999999928],
						[24.617450001000066, -27.915669996999952],
						[24.65831000000003, -27.852670002999957],
						[24.65866999700006, -27.790939992999938],
						[24.69547000400007, -27.718249999999955],
						[24.692299998000067, -27.64521999899995],
						[24.762060005000023, -27.633239999999944],
						[24.80117000000007, -27.70177999699996],
						[24.99972000100007, -27.680830003999972],
						[25.047909998000023, -27.69973999599995],
						[24.829840000000047, -27.931289999999933],
						[24.950559998000074, -28.11313999999993],
						[25.028080000000045, -28.07348000199994],
						[25.074650009000038, -28.064249995999944],
						[25.09060000200003, -27.984029998999972],
						[25.20094000100005, -27.886589998999966],
						[25.277410003000057, -27.795319995999932],
						[25.340420004000066, -27.792959998999947],
						[25.364029997000046, -27.750540000999933],
						[25.47943000300006, -27.69338000099998],
						[25.55583000200005, -27.686659997999982],
						[25.596609999000066, -27.65506999699994],
						[25.657800000000066, -27.69485999699998],
						[25.677420002000076, -27.630789996999965],
						[25.827370002000066, -27.56673000199993],
						[25.85260999700006, -27.620979999999975],
						[25.92687999700007, -27.60387000099996],
						[26.002289998000037, -27.648889992999955],
						[26.026190003000067, -27.73469999699995],
						[26.092639999000028, -27.696049998999968],
						[26.074959999000043, -27.621029998999973],
						[26.125510000000077, -27.564780009999936],
						[26.22724000200003, -27.51340999599995],
						[26.22041000300004, -27.47300000399997],
						[26.267750000000035, -27.416309997999974],
						[26.345160001000067, -27.38542999799995],
						[26.423090004000073, -27.40686999899998],
						[26.496769998000048, -27.26495999499997],
						[26.420610003000036, -27.17342999999994],
						[26.473629999000025, -27.15375999899993],
						[26.621069997000063, -27.00272000299998],
						[26.67182000200006, -26.99573000099997],
						[26.80502000200005, -26.931979998999964],
						[26.86858999800006, -26.919870000999936],
						[26.90868000000006, -26.945709999999963],
						[26.947220010000024, -26.89200999899998],
						[27.013929998000037, -26.932050001999983],
						[27.11343000200003, -26.926359996999963],
						[27.17366000100003, -26.96759000199995],
						[27.219160002000024, -26.944359995999946],
						[27.306050003000053, -26.85333999599993],
						[27.407530002000044, -26.925779989999967],
						[27.476040001000058, -26.883490000999927],
						[27.517359997000028, -26.781970000999934],
						[27.590429997000058, -26.73836000299997],
						[27.569090002000053, -26.647160003999943],
						[27.378349998000033, -26.610679997999966],
						[27.241869998000027, -26.636459999999943],
						[27.22835999700004, -26.571050000999946],
						[27.182637003000025, -26.574619995999967],
						[27.158760003000054, -26.52541999899995],
						[27.231421002000047, -26.50548099599996],
						[27.22484999900007, -26.44396999999998],
						[27.187952000000053, -26.377862998999944],
						[27.330071000000032, -26.28181499899995],
						[27.291409998000063, -26.144620003999933],
						[27.358259993000047, -26.154609999999934],
						[27.419440004000023, -26.117499995999935],
						[27.457009997000057, -25.981849997999973],
						[27.461947001000055, -25.867606000999956],
						[27.55984999800006, -25.842839998999978],
						[27.643549999000072, -25.79591999799993],
						[27.684930000000065, -25.875400000999946],
						[27.744549997000036, -25.894620002999943],
						[27.831470000000024, -25.86017299799994],
						[27.858739997000043, -25.81881999899997],
						[27.960169997000037, -25.815989996999974],
						[27.948190000000068, -25.695210003999932],
						[27.98056001200007, -25.632800006999958],
						[27.95763000100004, -25.59261999699993],
						[28.03595000400003, -25.470589996999934],
						[27.945639996000068, -25.40670000299997],
						[28.00040999600003, -25.35942000299997],
						[28.04473000400003, -25.401739994999957],
						[28.298060004000035, -25.33933999599998],
						[28.298160001000042, -25.310370001999956]
					]
				]
			},
			properties: {
				Shape_Leng: 26.0923773273,
				Shape_Area: 9.47782433583,
				ADM1_EN: 'North West',
				ADM1_PCODE: 'ZA6',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'NW'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[22.632170006000024, -26.121280000999946],
						[22.579580000000078, -26.15836999199996],
						[22.557409999000072, -26.221759994999957],
						[22.474240000000066, -26.19971000499993],
						[22.42220999500006, -26.223240002999944],
						[22.366780000000063, -26.319170002999954],
						[22.24725000500007, -26.34704000299996],
						[22.200240000000065, -26.42478000099993],
						[22.04823000600004, -26.635049994999974],
						[21.953129998000065, -26.66870999699995],
						[21.823310004000064, -26.659839999999974],
						[21.787390000000073, -26.676060003999964],
						[21.78019000300003, -26.802529997999955],
						[21.694839999000067, -26.861240003999967],
						[21.485859996000045, -26.84154999599997],
						[21.405429996000066, -26.822099994999974],
						[21.264560000000074, -26.837539996999965],
						[21.134170004000055, -26.87375999799997],
						[21.006629995000026, -26.844310002999975],
						[20.97782999900005, -26.811509998999952],
						[20.885230000000035, -26.79726999899998],
						[20.76311000000004, -26.86647000399995],
						[20.676149993000024, -26.861250003999942],
						[20.62242999700004, -26.78624999599998],
						[20.61689000000007, -26.67731000499998],
						[20.631460004000076, -26.584049998999944],
						[20.608559999000022, -26.554059999999936],
						[20.617299993000074, -26.443990003999943],
						[20.64614999500003, -26.43507999999997],
						[20.758920000000046, -26.286989999999946],
						[20.790290002000063, -26.27141000299997],
						[20.82278000100007, -26.176500011999963],
						[20.863279998000053, -26.13267999699997],
						[20.815350005000028, -26.00589999999994],
						[20.837430002000076, -25.950749993999978],
						[20.682559996000066, -25.69452000399997],
						[20.69818999900008, -25.595110000999966],
						[20.598279999000056, -25.421739997999964],
						[20.539229998000053, -25.34453000299993],
						[20.542890003000025, -25.292579994999983],
						[20.498920002000034, -25.228359999999952],
						[20.446380001000023, -25.198970001999953],
						[20.41255000500007, -25.082719993999945],
						[20.38417000100003, -25.03430000299994],
						[20.286079995000023, -24.969570003999934],
						[20.265709997000044, -24.92851999499993],
						[20.203730004000022, -24.896479994999936],
						[20.115829993000034, -24.88088999799993],
						[20.090240003000076, -24.83282000199995],
						[19.998870004000025, -24.765860007999947],
						[20.00019001000004, -25.53155999599994],
						[19.999419999000054, -26.14263000099993],
						[19.998839989000032, -26.61870999499996],
						[20.000069998000072, -27.190849998999965],
						[20.000450000000058, -27.98408999999998],
						[19.999159993000035, -28.42768000199993],
						[19.84723000400004, -28.46005000499997],
						[19.812989999000024, -28.508339992999936],
						[19.730049999000073, -28.487909996999974],
						[19.670849996000072, -28.529369997999936],
						[19.621900002000075, -28.511010002999967],
						[19.54847999800006, -28.540839999999946],
						[19.50677999800007, -28.597789992999935],
						[19.489680003000046, -28.681990000999974],
						[19.405399998000064, -28.73625999999996],
						[19.269790002000036, -28.74202999599993],
						[19.239820002000044, -28.805799999999977],
						[19.284870002000048, -28.90855999599995],
						[19.118289996000044, -28.969439998999974],
						[19.005929999000045, -28.924270003999936],
						[18.93564000400005, -28.857239995999976],
						[18.728670004000037, -28.83170000299998],
						[18.532780006000053, -28.868249998999943],
						[18.42346999700004, -28.90082000299998],
						[18.263490003000072, -28.879389997999965],
						[18.19382999900006, -28.915270002999932],
						[18.079240000000027, -28.869930006999937],
						[18.04606999400005, -28.874269992999928],
						[17.972239998000077, -28.79161999799993],
						[17.925650002000054, -28.76883999599994],
						[17.735770006000052, -28.756699995999952],
						[17.61867999800006, -28.76416000699993],
						[17.598860003000027, -28.694649996999942],
						[17.49366999600005, -28.69278999599993],
						[17.430169997000064, -28.721619998999984],
						[17.42966000100006, -28.56987000299995],
						[17.389129997000055, -28.57118000099996],
						[17.33308000100004, -28.47490999799993],
						[17.396520002000045, -28.427379996999946],
						[17.41403999700003, -28.376040005999982],
						[17.333999998000024, -28.226090004999946],
						[17.214980000000025, -28.248079996999934],
						[17.184150001000035, -28.208820000999935],
						[17.196259995000048, -28.12778999099993],
						[17.082499996000024, -28.033070000999942],
						[16.88459000200004, -28.08993998899996],
						[16.887929995000036, -28.17287999699994],
						[16.80305999600006, -28.22201999999993],
						[16.75501999900007, -28.302000001999943],
						[16.808160001000033, -28.360840002999964],
						[16.769370003000063, -28.39611999899995],
						[16.77682999800004, -28.44006000099995],
						[16.73399000200004, -28.494260002999965],
						[16.688469997000027, -28.47046999899993],
						[16.592459999000027, -28.53542000699997],
						[16.480209999000067, -28.565499993999936],
						[16.45189000000005, -28.63209999399993],
						[16.562309999000036, -28.71905000199996],
						[16.561909998000033, -28.758950005999964],
						[16.60475000200006, -28.876749994999955],
						[16.68981999300007, -28.92697000499993],
						[16.747930006000047, -29.042539998999928],
						[16.81511000000006, -29.09025000899993],
						[16.838039996000077, -29.21097999799997],
						[16.877369998000063, -29.292540002999942],
						[16.935140000000047, -29.35956999399997],
						[17.051570009000045, -29.67800000099993],
						[17.076659995000057, -29.815400000999944],
						[17.112550000000056, -29.91450999999995],
						[17.155119998000032, -29.97579999499993],
						[17.18231999900007, -30.092360006999968],
						[17.25831000100004, -30.256460003999962],
						[17.273790002000055, -30.33460000399998],
						[17.37074999500004, -30.49933999999996],
						[17.442349996000075, -30.596300000999975],
						[17.433960005000074, -30.620780001999947],
						[17.523589997000045, -30.735550001999968],
						[17.595329993000064, -30.90001000099994],
						[17.679419990000042, -30.99910000099993],
						[17.757580003000044, -31.15196999999995],
						[17.834419999000033, -31.176519999999982],
						[17.81132000100007, -31.09253999999993],
						[17.926409999000043, -31.011390002999974],
						[17.880299998000055, -30.92393999899997],
						[17.99337999900007, -30.91874000399997],
						[18.006479003000038, -30.791239995999945],
						[18.08917999700003, -30.787869995999984],
						[18.169180004000054, -30.848559998999974],
						[18.213540000000023, -30.810439991999942],
						[18.264169999000046, -30.818319993999978],
						[18.37103999900006, -30.659629996999968],
						[18.371150003000025, -30.592089999999928],
						[18.413759999000035, -30.527349999999956],
						[18.483619995000026, -30.52190999499993],
						[18.502150001000075, -30.44442000199996],
						[18.570120003000056, -30.43025999799994],
						[18.65514954100007, -30.556709298999976],
						[18.758710861000054, -30.56786918599994],
						[18.794500351000067, -30.667619704999936],
						[18.862970352000048, -30.717119216999947],
						[18.951900005000027, -30.74474000099997],
						[18.960470000000043, -30.866109999999935],
						[18.875390009000057, -30.887059999999963],
						[18.98449000100004, -30.945810002999963],
						[18.911770010000055, -30.978929996999966],
						[18.903470002000063, -31.041779994999956],
						[18.947600004000037, -31.112910003999957],
						[18.944460003000074, -31.237319997999975],
						[19.013010002000044, -31.305680002999964],
						[18.980130002000067, -31.355239989999973],
						[19.042989999000042, -31.424969999999973],
						[19.01968000100004, -31.499250003999975],
						[19.085420003000024, -31.526930000999982],
						[19.06556000300003, -31.706309998999984],
						[19.08627000200005, -31.794479999999965],
						[19.030459997000037, -31.83361999899995],
						[19.034579999000073, -31.876199997999947],
						[19.395849996000038, -32.01511000299996],
						[19.515190005000022, -32.11519999999996],
						[19.49150000000003, -32.25237000599998],
						[19.409080002000053, -32.29007999799995],
						[19.430200004000028, -32.36570999899993],
						[19.496370003000038, -32.47481999799993],
						[19.48680500300003, -32.56543999599995],
						[19.528249996000056, -32.67323999799993],
						[19.60495000000003, -32.62945999799996],
						[19.621850004000066, -32.47062000099993],
						[19.730240002000073, -32.44235999999995],
						[19.802700001000062, -32.393700001999946],
						[19.93749000300005, -32.37727999799995],
						[20.09696000300005, -32.25023999899997],
						[20.240840003000073, -32.22418999599995],
						[20.21603000500005, -32.30315999499993],
						[20.163520004000077, -32.35102000599994],
						[20.132020001000058, -32.42112000299994],
						[20.079690004000042, -32.39749999399993],
						[20.096810000000062, -32.50295999699995],
						[20.14119000200003, -32.643739995999965],
						[20.191720000000032, -32.68575999999996],
						[20.187609997000038, -32.752670002999935],
						[20.219040003000032, -32.78473999499994],
						[20.299899996000022, -32.80495999899995],
						[20.38004999900005, -32.90184999999997],
						[20.43859999500006, -32.940060003999974],
						[20.499299989000065, -32.941629992999935],
						[20.561230000000023, -32.880969998999944],
						[20.59210000400003, -32.92646999899995],
						[20.731170002000056, -32.944994994999945],
						[20.798560000000066, -32.89474999999993],
						[20.832430000000045, -32.81737000299995],
						[20.792200000000037, -32.73503001199998],
						[20.84410000400004, -32.66243999499994],
						[20.962780000000066, -32.639299996999966],
						[21.06028999600005, -32.65550000199994],
						[21.156979997000064, -32.62893999399995],
						[21.14011000200003, -32.58976999399994],
						[21.18208000000004, -32.50868000299994],
						[21.269479997000076, -32.45029000099993],
						[21.303010011000026, -32.402440001999935],
						[21.475640003000024, -32.33145000199994],
						[21.561809999000047, -32.314730001999976],
						[21.536010000000033, -32.22922000999995],
						[21.64457999800004, -32.20871000099993],
						[21.691649995000034, -32.24857000199995],
						[21.73589000000004, -32.20502000099998],
						[21.78061999700003, -32.25092999999998],
						[21.855109998000046, -32.275509994999936],
						[21.92460000600005, -32.26196000099998],
						[21.936205003000055, -32.22288000399993],
						[21.995920002000048, -32.20298000399998],
						[22.016439990000038, -32.11425999499994],
						[22.069560000000024, -32.08144999899997],
						[22.094980004000035, -32.00105999899995],
						[22.07133000300007, -31.939299996999978],
						[22.101439998000046, -31.898719994999965],
						[22.166599999000027, -31.893089998999983],
						[22.176880003000065, -31.82071999799996],
						[22.26010000200006, -31.662470000999974],
						[22.272920000000056, -31.592540000999975],
						[22.312290002000054, -31.58346000199998],
						[22.495760001000065, -31.67033999599994],
						[22.56481499000006, -31.677919994999968],
						[22.619070003000047, -31.72465000099993],
						[22.578340001000072, -31.80551000099996],
						[22.65152999700007, -31.821670001999962],
						[22.73510000500005, -31.79937999599997],
						[22.776880000000062, -31.85690999999997],
						[22.858970002000035, -31.818289999999934],
						[22.901950001000046, -31.875769997999953],
						[22.975830002000066, -31.860829998999975],
						[23.067390000000046, -31.89073999599998],
						[23.052589999000077, -31.939780000999974],
						[23.087619999000026, -31.972290000999976],
						[23.139449995000064, -31.951539998999976],
						[23.23036999900006, -31.87569000299993],
						[23.263440003000028, -31.778340000999947],
						[23.30242000000004, -31.730149998999934],
						[23.496109997000076, -31.702689998999972],
						[23.715130000000045, -31.64704000399996],
						[23.756489996000028, -31.69571000199994],
						[23.847620002000042, -31.729219996999973],
						[23.808520002000023, -31.76365999799998],
						[23.878630002000023, -31.833680004999962],
						[23.94865999900003, -31.773330000999977],
						[23.96306000100003, -31.706670006999957],
						[24.028519997000046, -31.730170000999976],
						[24.070940002000043, -31.807089996999935],
						[24.152459995000072, -31.78860999799997],
						[24.161589996000032, -31.740149993999978],
						[24.26825000300005, -31.76666999699995],
						[24.345990001000075, -31.714480004999984],
						[24.514129996000065, -31.704970000999936],
						[24.522960003000037, -31.603689997999936],
						[24.503910002000055, -31.568419998999957],
						[24.558850001000053, -31.481839995999962],
						[24.56719000100003, -31.41864000099997],
						[24.664990001000035, -31.38366000999997],
						[24.704810003000034, -31.400590001999944],
						[24.788679998000077, -31.389460002999954],
						[24.852990005000038, -31.328209989999948],
						[24.94197000500003, -31.315069998999945],
						[25.00562000000008, -31.263099998999962],
						[25.05847000400007, -31.269379999999956],
						[25.170479998000076, -31.23917999899993],
						[25.22504000300006, -31.195199999999943],
						[25.354419997000036, -31.23599999399994],
						[25.38621000100005, -31.21784000399998],
						[25.384560001000068, -31.150970000999962],
						[25.446389999000075, -31.10020000199995],
						[25.486750001000075, -31.036910003999935],
						[25.47502000000003, -30.983879999999942],
						[25.51759000000004, -30.903389997999966],
						[25.471289999000078, -30.869840000999943],
						[25.521629998000037, -30.83318000099996],
						[25.48020000200006, -30.77890999999994],
						[25.467099997000048, -30.624210010999946],
						[25.376580002000026, -30.55988999699997],
						[25.307119999000065, -30.57707999799993],
						[25.23710999900004, -30.50122999299998],
						[25.151909997000075, -30.45729999699995],
						[25.09371999700005, -30.37145999699993],
						[25.035619999000062, -30.34420999799994],
						[24.90156000500008, -30.208240003999947],
						[24.86768999700007, -30.130939997999974],
						[24.796240003000037, -30.04483999799993],
						[24.793970003000027, -29.99897999799998],
						[24.67129999900004, -29.971449999999948],
						[24.667799998000078, -29.906509994999965],
						[24.60792999800003, -29.91126000299994],
						[24.543859997000027, -29.843299999999942],
						[24.411580000000072, -29.79073999999997],
						[24.34866000100004, -29.70198999799993],
						[24.347519998000053, -29.65449999599997],
						[24.66192000500007, -29.079159998999955],
						[24.90184000000005, -28.64803000099994],
						[24.827729996000073, -28.62695999699997],
						[24.93761998900004, -28.324919989999955],
						[24.890329997000038, -28.31023000099998],
						[24.926679998000054, -28.24689999499998],
						[24.964569994000044, -28.25073999899996],
						[25.028080000000045, -28.07348000199994],
						[24.950559998000074, -28.11313999999993],
						[24.829840000000047, -27.931289999999933],
						[25.047909998000023, -27.69973999599995],
						[24.99972000100007, -27.680830003999972],
						[24.80117000000007, -27.70177999699996],
						[24.762060005000023, -27.633239999999944],
						[24.692299998000067, -27.64521999899995],
						[24.69547000400007, -27.718249999999955],
						[24.65866999700006, -27.790939992999938],
						[24.65831000000003, -27.852670002999957],
						[24.617450001000066, -27.915669996999952],
						[24.62935000300007, -27.994309999999928],
						[24.56281000000007, -28.036220000999947],
						[24.534620004000033, -28.092109999999934],
						[24.465479997000045, -28.035840005999944],
						[24.46728999900006, -27.980569998999954],
						[24.40994999800006, -27.923300001999962],
						[24.360459994000053, -27.91067000299995],
						[24.452310005000072, -27.782880002999946],
						[24.408839999000065, -27.761099996999974],
						[24.44676000000004, -27.70285000399997],
						[24.40528000100005, -27.681180001999962],
						[24.111000001000036, -27.73898000099996],
						[24.093339996000054, -27.704910005999977],
						[24.118620004000036, -27.621739997999953],
						[24.050610001000052, -27.602729996999983],
						[24.063919998000074, -27.35316999899993],
						[23.89646999400003, -27.252659998999945],
						[23.973560000000077, -27.096379997999975],
						[24.037450000000035, -27.053699998999946],
						[24.026019999000027, -26.99928999699995],
						[23.97037000100005, -26.894200001999934],
						[23.916070004000062, -26.858289997999975],
						[23.853230004000068, -26.890140002999942],
						[23.760750002000066, -26.840960000999928],
						[23.646530002000077, -26.807480001999977],
						[23.48713000300006, -26.739709004999952],
						[23.583750000000066, -26.617149997999945],
						[23.46295999800003, -26.53108999799997],
						[23.266410002000043, -26.48539999899998],
						[23.28205000300005, -26.339470002999974],
						[23.221740004000026, -26.271270000999948],
						[23.310979995000025, -26.141849999999977],
						[23.215819999000075, -26.115730003999943],
						[23.23214999700008, -26.052690002999952],
						[23.35388199700003, -26.08947800599998],
						[23.387359998000022, -26.006159999999966],
						[23.320549997000057, -25.99283999599993],
						[23.086910001000035, -25.982559995999964],
						[23.064800003000073, -26.099059994999948],
						[22.987040000000036, -26.089979995999954],
						[22.981149999000024, -26.152559999999937],
						[22.90705999900007, -26.14592000199997],
						[22.899290004000022, -26.213630000999956],
						[22.84187000000003, -26.39330000299998],
						[22.803159997000023, -26.453680000999952],
						[22.708800001000043, -26.410789998999974],
						[22.702940002000048, -26.11985000599998],
						[22.632170006000024, -26.121280000999946]
					]
				]
			},
			properties: {
				Shape_Leng: 48.0297644044,
				Shape_Area: 34.6915543572,
				ADM1_EN: 'Nothern Cape',
				ADM1_PCODE: 'ZA3',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'NC'
			}
		},
		{
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[24.152459995000072, -31.78860999799997],
						[24.070940002000043, -31.807089996999935],
						[24.028519997000046, -31.730170000999976],
						[23.96306000100003, -31.706670006999957],
						[23.94865999900003, -31.773330000999977],
						[23.878630002000023, -31.833680004999962],
						[23.808520002000023, -31.76365999799998],
						[23.847620002000042, -31.729219996999973],
						[23.756489996000028, -31.69571000199994],
						[23.715130000000045, -31.64704000399996],
						[23.496109997000076, -31.702689998999972],
						[23.30242000000004, -31.730149998999934],
						[23.263440003000028, -31.778340000999947],
						[23.23036999900006, -31.87569000299993],
						[23.139449995000064, -31.951539998999976],
						[23.087619999000026, -31.972290000999976],
						[23.052589999000077, -31.939780000999974],
						[23.067390000000046, -31.89073999599998],
						[22.975830002000066, -31.860829998999975],
						[22.901950001000046, -31.875769997999953],
						[22.858970002000035, -31.818289999999934],
						[22.776880000000062, -31.85690999999997],
						[22.73510000500005, -31.79937999599997],
						[22.65152999700007, -31.821670001999962],
						[22.578340001000072, -31.80551000099996],
						[22.619070003000047, -31.72465000099993],
						[22.56481499000006, -31.677919994999968],
						[22.495760001000065, -31.67033999599994],
						[22.312290002000054, -31.58346000199998],
						[22.272920000000056, -31.592540000999975],
						[22.26010000200006, -31.662470000999974],
						[22.176880003000065, -31.82071999799996],
						[22.166599999000027, -31.893089998999983],
						[22.101439998000046, -31.898719994999965],
						[22.07133000300007, -31.939299996999978],
						[22.094980004000035, -32.00105999899995],
						[22.069560000000024, -32.08144999899997],
						[22.016439990000038, -32.11425999499994],
						[21.995920002000048, -32.20298000399998],
						[21.936205003000055, -32.22288000399993],
						[21.92460000600005, -32.26196000099998],
						[21.855109998000046, -32.275509994999936],
						[21.78061999700003, -32.25092999999998],
						[21.73589000000004, -32.20502000099998],
						[21.691649995000034, -32.24857000199995],
						[21.64457999800004, -32.20871000099993],
						[21.536010000000033, -32.22922000999995],
						[21.561809999000047, -32.314730001999976],
						[21.475640003000024, -32.33145000199994],
						[21.303010011000026, -32.402440001999935],
						[21.269479997000076, -32.45029000099993],
						[21.18208000000004, -32.50868000299994],
						[21.14011000200003, -32.58976999399994],
						[21.156979997000064, -32.62893999399995],
						[21.06028999600005, -32.65550000199994],
						[20.962780000000066, -32.639299996999966],
						[20.84410000400004, -32.66243999499994],
						[20.792200000000037, -32.73503001199998],
						[20.832430000000045, -32.81737000299995],
						[20.798560000000066, -32.89474999999993],
						[20.731170002000056, -32.944994994999945],
						[20.59210000400003, -32.92646999899995],
						[20.561230000000023, -32.880969998999944],
						[20.499299989000065, -32.941629992999935],
						[20.43859999500006, -32.940060003999974],
						[20.38004999900005, -32.90184999999997],
						[20.299899996000022, -32.80495999899995],
						[20.219040003000032, -32.78473999499994],
						[20.187609997000038, -32.752670002999935],
						[20.191720000000032, -32.68575999999996],
						[20.14119000200003, -32.643739995999965],
						[20.096810000000062, -32.50295999699995],
						[20.079690004000042, -32.39749999399993],
						[20.132020001000058, -32.42112000299994],
						[20.163520004000077, -32.35102000599994],
						[20.21603000500005, -32.30315999499993],
						[20.240840003000073, -32.22418999599995],
						[20.09696000300005, -32.25023999899997],
						[19.93749000300005, -32.37727999799995],
						[19.802700001000062, -32.393700001999946],
						[19.730240002000073, -32.44235999999995],
						[19.621850004000066, -32.47062000099993],
						[19.60495000000003, -32.62945999799996],
						[19.528249996000056, -32.67323999799993],
						[19.48680500300003, -32.56543999599995],
						[19.496370003000038, -32.47481999799993],
						[19.430200004000028, -32.36570999899993],
						[19.409080002000053, -32.29007999799995],
						[19.49150000000003, -32.25237000599998],
						[19.515190005000022, -32.11519999999996],
						[19.395849996000038, -32.01511000299996],
						[19.034579999000073, -31.876199997999947],
						[19.030459997000037, -31.83361999899995],
						[19.08627000200005, -31.794479999999965],
						[19.06556000300003, -31.706309998999984],
						[19.085420003000024, -31.526930000999982],
						[19.01968000100004, -31.499250003999975],
						[19.042989999000042, -31.424969999999973],
						[18.980130002000067, -31.355239989999973],
						[19.013010002000044, -31.305680002999964],
						[18.944460003000074, -31.237319997999975],
						[18.947600004000037, -31.112910003999957],
						[18.903470002000063, -31.041779994999956],
						[18.911770010000055, -30.978929996999966],
						[18.98449000100004, -30.945810002999963],
						[18.875390009000057, -30.887059999999963],
						[18.960470000000043, -30.866109999999935],
						[18.951900005000027, -30.74474000099997],
						[18.862970352000048, -30.717119216999947],
						[18.794500351000067, -30.667619704999936],
						[18.758710861000054, -30.56786918599994],
						[18.65514954100007, -30.556709298999976],
						[18.570120003000056, -30.43025999799994],
						[18.502150001000075, -30.44442000199996],
						[18.483619995000026, -30.52190999499993],
						[18.413759999000035, -30.527349999999956],
						[18.371150003000025, -30.592089999999928],
						[18.37103999900006, -30.659629996999968],
						[18.264169999000046, -30.818319993999978],
						[18.213540000000023, -30.810439991999942],
						[18.169180004000054, -30.848559998999974],
						[18.08917999700003, -30.787869995999984],
						[18.006479003000038, -30.791239995999945],
						[17.99337999900007, -30.91874000399997],
						[17.880299998000055, -30.92393999899997],
						[17.926409999000043, -31.011390002999974],
						[17.81132000100007, -31.09253999999993],
						[17.834419999000033, -31.176519999999982],
						[17.757580003000044, -31.15196999999995],
						[17.877319999000065, -31.27877000199993],
						[17.90044000100005, -31.352060002999963],
						[18.09782999600003, -31.55937999799994],
						[18.222789996000074, -31.74432000099995],
						[18.23358999800007, -31.82071000899998],
						[18.28007999700003, -31.898170000999983],
						[18.265459989000078, -31.934039996999957],
						[18.30796000400005, -32.05199999599995],
						[18.31031000300004, -32.17262000399995],
						[18.342220002000033, -32.265699998999935],
						[18.314230000000066, -32.31651999999997],
						[18.332380003000026, -32.49335000399998],
						[18.279430002000026, -32.63322999799993],
						[18.161499997000078, -32.758679996999945],
						[18.060350003000053, -32.783539996999934],
						[17.957650000000058, -32.718089996999936],
						[17.896990000000073, -32.740649995999945],
						[17.878779999000074, -32.91898999899996],
						[17.891440002000024, -33.028639994999935],
						[17.99274999900007, -32.997160005999945],
						[18.042680001000065, -33.04868000099998],
						[17.955269998000063, -33.110570002999964],
						[18.106490001000054, -33.24069999799997],
						[18.166039994000073, -33.36861000099998],
						[18.255050004000054, -33.42675000099996],
						[18.437959998000053, -33.69256000399997],
						[18.449770001000047, -33.78182000099997],
						[18.488699997000026, -33.851910002999944],
						[18.46521999600003, -33.91209999999995],
						[18.398259997000025, -33.90088000199995],
						[18.369799999000065, -33.974599988999955],
						[18.31063000200004, -34.04329000299998],
						[18.35694999900005, -34.11038000299993],
						[18.31833000300003, -34.14590999599994],
						[18.362840000000062, -34.184369996999976],
						[18.40219999800007, -34.309650002999945],
						[18.45322000300007, -34.336669996999944],
						[18.475430001000063, -34.23044999799998],
						[18.426410003000058, -34.17718999699997],
						[18.46909000100004, -34.109140010999965],
						[18.597439997000038, -34.07760999899995],
						[18.69465999700003, -34.07210999999995],
						[18.813380004000066, -34.10132999699994],
						[18.86811999300005, -34.16047999799997],
						[18.81973000100004, -34.185329999999965],
						[18.852769996000063, -34.238100000999964],
						[18.811909997000043, -34.298769998999944],
						[18.82714999800004, -34.37609999799997],
						[19.047080004000065, -34.34218999999996],
						[19.218480003000025, -34.43812000099996],
						[19.275380003000066, -34.40905000099997],
						[19.357739998000056, -34.485480002999964],
						[19.378119998000045, -34.540390000999935],
						[19.32616001100007, -34.61018999999993],
						[19.402229997000063, -34.60641999999996],
						[19.449149999000042, -34.65463000099993],
						[19.515820002000055, -34.66974000099998],
						[19.596049997000023, -34.74666999999994],
						[19.691350000000057, -34.76315999899998],
						[19.87223000000006, -34.76589999999993],
						[19.989179998000054, -34.83337000299997],
						[20.079780001000074, -34.73651000199993],
						[20.162939996000034, -34.697499996999966],
						[20.232589997000048, -34.68962000399995],
						[20.258840002000056, -34.63828999899994],
						[20.407240002000037, -34.56343000199996],
						[20.47609000400007, -34.492329997999946],
						[20.597849998000072, -34.455270000999974],
						[20.691119999000023, -34.45026999999993],
						[20.84837999900003, -34.47234999699998],
						[20.854629999000053, -34.39783000299997],
						[20.904079999000032, -34.37254999899994],
						[21.001179997000065, -34.36495000299993],
						[21.13432000000006, -34.38354999699993],
						[21.29070999700008, -34.43676999699994],
						[21.413130008000053, -34.401359997999975],
						[21.450089999000056, -34.36753999999996],
						[21.53569999900003, -34.35636999999997],
						[21.69624999800004, -34.394990003999965],
						[21.870990002000042, -34.362870002999955],
						[21.930929997000078, -34.30416999999994],
						[21.932249999000078, -34.24513000299993],
						[22.010339996000027, -34.211060001999954],
						[22.112190008000027, -34.20380999899993],
						[22.12594999600003, -34.11492999799998],
						[22.15952999800004, -34.084139995999976],
						[22.298150003000046, -34.05119000099995],
						[22.484639999000024, -34.05125999599994],
						[22.563649999000063, -33.99610999999993],
						[22.780119997000043, -34.02771999799995],
						[22.970259997000028, -34.08607000799998],
						[23.13030999800003, -34.08043000199996],
						[23.286390004000054, -34.101719997999965],
						[23.37552000000005, -34.09816000099994],
						[23.384460002000026, -34.04006000199996],
						[23.437879998000028, -34.00864000299998],
						[23.561899999000048, -33.98187000399997],
						[23.647020000000055, -33.98055999999997],
						[23.65522999800004, -33.88738999699996],
						[23.517920004000075, -33.78562000299996],
						[23.468049999000073, -33.80747999999994],
						[23.430070000000057, -33.761759997999945],
						[23.43994000200007, -33.717390000999956],
						[23.54127000400007, -33.699539999999956],
						[23.555529998000054, -33.67295999799995],
						[23.670440004000056, -33.67255999799994],
						[23.674980000000062, -33.62587001199995],
						[23.596199999000078, -33.572520003999955],
						[23.603999999000052, -33.49640000199997],
						[23.495619998000052, -33.44344001099995],
						[23.354879999000048, -33.441169996999975],
						[23.297124998000072, -33.38864000099994],
						[23.134800004000056, -33.38762000099996],
						[22.93478000300007, -33.42914000099995],
						[22.784499998000058, -33.41553000199997],
						[22.735740001000067, -33.39476999799996],
						[22.892269998000074, -33.14163000399998],
						[22.955310001000043, -33.073140000999956],
						[22.935210005000044, -33.01304000299996],
						[22.948750001000064, -32.950040000999934],
						[23.007439997000063, -32.872819998999944],
						[23.098009998000066, -32.87369000899997],
						[23.08935000100007, -32.79917999699995],
						[23.149329996000063, -32.766739997999935],
						[23.37862000100006, -32.82501999599998],
						[23.30130999800008, -32.65178999899996],
						[23.288155001000064, -32.55120999799993],
						[23.24447000400005, -32.513229998999975],
						[23.221610003000023, -32.42503999999997],
						[23.307329999000046, -32.39592000199997],
						[23.33305000400003, -32.35113999799995],
						[23.40985000200004, -32.38919999899997],
						[23.448959998000078, -32.323269997999944],
						[23.66514999900005, -32.344229997999946],
						[23.648870002000024, -32.29801999599994],
						[23.670450002000052, -32.23767000399994],
						[23.79785000100003, -32.19407000299998],
						[23.892299997000066, -32.25494999599994],
						[23.961149999000042, -32.20652000399997],
						[24.100129996000078, -32.16399999999993],
						[24.13552999700005, -32.12314000099997],
						[24.10967499700007, -32.084289998999964],
						[24.140870001000053, -32.01170999799996],
						[24.222410000000025, -31.95564000099995],
						[24.164199997000026, -31.902410002999943],
						[24.105380000000025, -31.906850001999942],
						[24.152459995000072, -31.78860999799997]
					]
				]
			},
			properties: {
				Shape_Leng: 38.1528481969,
				Shape_Area: 12.4946784559,
				ADM1_EN: 'Western Cape',
				ADM1_PCODE: 'ZA1',
				ADM1_REF: '',
				ADM1ALT1EN: '',
				ADM1ALT2EN: '',
				ADM0_EN: 'South Africa',
				ADM0_PCODE: 'ZA',
				date: '2018-12-27T00:00:00.000Z',
				validOn: '2020-11-09T00:00:00.000Z',
				validTo: '1899-11-30T00:00:00.000Z',
				ADM1_ID: 'WC'
			}
		}
	]
};

export { provinceMap };
